<app-dialog [title]="title" [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Create', isDisabled:!radioOption.value || !selectedVendor.value, spin:spin}]"
    (action)="dialogAction($event)" (close)="close()">
    <div class="mapping-popup">
        <div class="grid-header_search pt-4 pb-3">
            <div class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                    <label class="me-3 font_size_12">New Product ID:</label>
                    <mat-radio-group class="label_selection" [formControl]="radioOption">
                        <div class="row">
                            <div class="col-md-6">
                                <mat-radio-button value="ASIN">ASIN</mat-radio-button>
                            </div>
                            <div class="col-md-6">
                                <mat-radio-button value="SKU">SKU</mat-radio-button>
                            </div>
                        </div>
                    </mat-radio-group>
                    <!-- <app-radio-group-renderer [radioButtonOptions]="radioButtonOptions" [buttonFormControl]="radioOption"></app-radio-group-renderer> -->
                </div>
                <div class="ms-auto">
                    <label class="input-container_label mb-0 me-2" for="">Choose vendor</label>
                    <select type="text" class="input-container_input" [formControl]="selectedVendor">
                        <option value="null" class="mat-option-override" disabled selected>Select</option>
                        <option [value]="item.vendorId" *ngFor="let item of data.vendorList">{{ item.name }}</option>
                      </select>
                    <!-- <app-dropdown-renderer [dropdownOptions]="data.vendorList" [dropdownFormControl]="selectedVendor"></app-dropdown-renderer> -->
                </div>
            </div>
        </div>
        <div class="sku-list pt-4 pb-4 m-auto text-center">
            We will create a product for every listing in your catalog,
            the product ID will be based on the listing ASIN
        </div>
    </div>
</app-dialog>